import { render } from "./index.vue?vue&type=template&id=e171da44"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/reaction/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e171da44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e171da44', __exports__)) {
    console.log('reload')
    api.reload('e171da44', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e171da44", () => {
    console.log('re-render')
    api.rerender('e171da44', render)
  })

}


export default __exports__